import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const PublicLandingPage: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try {
      // Check if user explicitly logged out (check both storages)
      const requireLogin = localStorage.getItem('explicit_logout') === 'true' || 
                          sessionStorage.getItem('explicit_logout') === 'true';
      
      console.log('🔍 Sign In - Force login?', requireLogin);
      
      const response = await axios.get('/api/auth/oauth/init', {
        params: { force_login: requireLogin }
      });
      const { authUrl } = response.data;
      window.location.href = authUrl;
    } catch (error) {
      console.error('Failed to initiate OAuth:', error);
      setLoading(false);
    }
  };

  return (
    <div className="landing-page">
      <div className="landing-shell">
        <div className="card landing-card">
          <div className="landing-icon">🏛️</div>
          <h1 className="landing-title">Welcome to Patriotic Projects</h1>
          <p className="landing-subtitle">
          A collaborative platform for developers and teams to build amazing projects together.
          </p>

          <div className="landing-actions">
            <button 
              onClick={handleSignIn}
              className="btn btn-primary landing-primary"
              disabled={loading}
            >
              {loading ? '🔄 Redirecting...' : '🚀 Signin or Register'}
            </button>
          
            <Link to="/dashboard" className="btn btn-secondary landing-secondary">
              👤 Continue as Guest
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicLandingPage;
